import { render, staticRenderFns } from "./swiper-btn-wrap.vue?vue&type=template&id=b705010c&scoped=true&"
import script from "./swiper-btn-wrap.vue?vue&type=script&lang=js&"
export * from "./swiper-btn-wrap.vue?vue&type=script&lang=js&"
import style0 from "./swiper-btn-wrap.vue?vue&type=style&index=0&id=b705010c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b705010c",
  null
  
)

export default component.exports